import React, { useState, useEffect } from 'react';
import { FaTimes } from 'react-icons/fa';
import './SearchBar.css';

interface SearchBarProps {
  onSearch: (query: string) => void;
  onClearFilters?: () => void;
  minChars?: number;
  onTutorialProgress?: (value: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({ 
  onSearch, 
  onClearFilters,
  minChars = 3,
  onTutorialProgress
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    if (searchTerm.length >= minChars) {
      onSearch(searchTerm);
    } else if (searchTerm.length === 0) {
      onSearch('');
    }
    
    // Notificar al tutorial sobre el progreso
    if (onTutorialProgress) {
      onTutorialProgress(searchTerm);
    }
  }, [searchTerm, minChars, onSearch, onTutorialProgress]);

  const handleClearSearch = () => {
    setSearchTerm('');
    onClearFilters?.();
  };

  return (
    <div className="search-bar">
      <div className="search-input-container">
        <label htmlFor="search-ships" className="visually-hidden">Buscar nave</label>
        <input
          id="search-ships"
          type="text"
          placeholder="Buscar nave..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          data-tutorial-target="search-bar"
        />
        {searchTerm && (
          <button 
            className="clear-search"
            onClick={handleClearSearch}
            title="Limpiar búsqueda y filtros"
          >
            <FaTimes />
          </button>
        )}
      </div>
      {searchTerm.length > 0 && searchTerm.length < minChars && (
        <div className="search-hint">
          Introduce al menos {minChars} caracteres
        </div>
      )}
    </div>
  );
}; 